import { takeLatest } from "redux-saga/effects";
import * as ActionsTypes from "../../../common/state/StateConstants";
import {
  getTiEtatsSaga,
  getTiCategoriesSaga,
  searchTitresSaga,
  getTiStatusModifSaga,
  getTiTypeMessageSaga,
  getTiBanqueSaga,
  searchGuichetsSaga,
  getTiLocalitesSaga,
  searchDeclarantsSaga,
  getTiTypeTESaga,
  getTiTypeTISaga,
  searchNomenclaturesSaga,
  searchImportateursSaga,
  searchAllTitresSaga,
  downloadTiDocumentSaga,
  downloadTiFactureDocumentSaga,
  downloadTiSaga,
  getTiByIdSaga,
  fetchTiHistoriqueSaga,
  getTiDepartmentsSaga,
  transferTiSaga,
  transferTiProlongSaga,
  getTiDecisionTypeMCESaga,
  TiDecisionMCESaga,
  TiDecisionDEPSaga,
  getTiDecisionTypeMCEProlongSaga,
  TiProlongMCESaga,
  TiProlongDEPSaga,
  getTiColumnsDensityStateSaga,
  postTiColumnsDensityStateSaga,
  fetchKpiTiSaga,
  authenticateSaga,
  registerMFASaga,
  sendOtpMailSaga,
  postChangePasswordSaga,
  getReponseDomiciliationBanqueDataSaga,
  getTypeReglementSaga,
  getTiApurementSaga,
  acceptDomiciliationBanqueSaga,
  refuseDomiciliationBanqueSaga,
  getModeReglementSaga,
  postDonnesReglementsSaga,
} from "./TiSaga";

export default function* tiWatcher() {
  yield takeLatest(ActionsTypes.SEARCH_TITRE, searchTitresSaga);
  yield takeLatest(ActionsTypes.FETCH_TI_GUICHETS, searchGuichetsSaga);
  yield takeLatest(ActionsTypes.FETCH_TI_ETATS, getTiEtatsSaga);
  yield takeLatest(ActionsTypes.FETCH_TI_CATEGORIES, getTiCategoriesSaga);
  yield takeLatest(ActionsTypes.FETCH_TI_STATUS_MODIF, getTiStatusModifSaga);
  yield takeLatest(ActionsTypes.FETCH_TI_TYPE_MESSAGE, getTiTypeMessageSaga);
  yield takeLatest(ActionsTypes.FETCH_TI_BANQUE, getTiBanqueSaga);
  yield takeLatest(ActionsTypes.FETCH_TYPE_REGLEMENT, getTypeReglementSaga);
  yield takeLatest(ActionsTypes.FETCH_MODE_REGLEMENT, getModeReglementSaga);
  yield takeLatest(ActionsTypes.FETCH_TI_APUREMENT, getTiApurementSaga);
  yield takeLatest(ActionsTypes.FETCH_TI_LOCALITES, getTiLocalitesSaga);
  yield takeLatest(ActionsTypes.FETCH_TI_DECLARANTS, searchDeclarantsSaga);
  yield takeLatest(ActionsTypes.FETCH_TI_TYPE_TE, getTiTypeTESaga);
  yield takeLatest(ActionsTypes.FETCH_TI_TYPE_TI, getTiTypeTISaga);
  yield takeLatest(
    ActionsTypes.FETCH_TI_NOMENCLATURES,
    searchNomenclaturesSaga
  );
  yield takeLatest(ActionsTypes.FETCH_TI_IMPORTATEURS, searchImportateursSaga);
  yield takeLatest(ActionsTypes.SEARCH_ALL_TITRES, searchAllTitresSaga);
  yield takeLatest(ActionsTypes.FETCH_TI, getTiByIdSaga);
  yield takeLatest(ActionsTypes.DOWNLOAD_TI, downloadTiSaga);
  yield takeLatest(
    ActionsTypes.DOWNLOAD_TI_FACTURE_DOCUMENT,
    downloadTiFactureDocumentSaga
  );
  yield takeLatest(ActionsTypes.DOWNLOAD_TI_DOCUMENT, downloadTiDocumentSaga);
  yield takeLatest(ActionsTypes.FETCH_HISTORIQUE_TI, fetchTiHistoriqueSaga);
  yield takeLatest(ActionsTypes.FETCH_DEPARTMENTS_TI, getTiDepartmentsSaga);
  yield takeLatest(ActionsTypes.TRANSFER_TI, transferTiSaga);
  yield takeLatest(ActionsTypes.TRANSFER_TI_PROLONG, transferTiProlongSaga);
  yield takeLatest(
    ActionsTypes.FETCH_TI_TYPE_DECISION_MCE,
    getTiDecisionTypeMCESaga
  );
  yield takeLatest(ActionsTypes.POST_TI_DECISION_MCE, TiDecisionMCESaga);
  yield takeLatest(ActionsTypes.POST_TI_DECISION_DEP, TiDecisionDEPSaga);
  yield takeLatest(
    ActionsTypes.FETCH_TI_TYPE_DECISION_MCE_PROLONG,
    getTiDecisionTypeMCEProlongSaga
  );
  yield takeLatest(ActionsTypes.POST_TI_PROLONG_MCE, TiProlongMCESaga);
  yield takeLatest(ActionsTypes.POST_TI_PROLONG_DEP, TiProlongDEPSaga);
  yield takeLatest(
    ActionsTypes.SET_TI_COLUMNS_DENSITY_STATE,
    postTiColumnsDensityStateSaga
  );
  yield takeLatest(
    ActionsTypes.GET_TI_COLUMNS_DENSITY_STATE,
    getTiColumnsDensityStateSaga
  );
  yield takeLatest(ActionsTypes.TI_KPI, fetchKpiTiSaga);
  yield takeLatest(ActionsTypes.AUTHENTICATE_USER, authenticateSaga);
  yield takeLatest(ActionsTypes.REGISTER_MFA, registerMFASaga);
  yield takeLatest(ActionsTypes.SEND_OTP_MAIL, sendOtpMailSaga);
  yield takeLatest(ActionsTypes.POST_CHANGE_PASSWORD, postChangePasswordSaga);
  yield takeLatest(
    ActionsTypes.GET_REPONSE_DOMICILIATION_BANQUE_DATA,
    getReponseDomiciliationBanqueDataSaga
  );
  yield takeLatest(
    ActionsTypes.ACCEPT_DOMICILIATION_BANQUE,
    acceptDomiciliationBanqueSaga
  );
  yield takeLatest(
    ActionsTypes.REFUSE_DOMICILIATION_BANQUE,
    refuseDomiciliationBanqueSaga
  );
  yield takeLatest(
    ActionsTypes.POST_DONNEES_REGLEMENT,
    postDonnesReglementsSaga
  );
}
